import { createContext, useContext } from "react";

import { AuthContext } from "./AuthContext";
import useLabourer from "../hooks/useLabourer";

export const LabourerContext = createContext();

export const LabourerProvider = ({ children }) => {
  const { user } = useContext(AuthContext);

  const { data, isLoading, mutate } = useLabourer({ shouldFetch: !!user, userId: user?._id });
  const labourer = data?.labourer;

  return (
    <LabourerContext.Provider value={{
      labourer,
      isLoadingLabourer: isLoading,
      mutateLabourer: mutate
    }}>
      {children}
    </LabourerContext.Provider>
  )
}